import { observer } from 'mobx-react';
import * as React from 'react';
import { PAYMENT_TYPES } from 'src/constants/main';
import { cartStore } from 'src/mobx/cartStore';
import { checkoutStore } from 'src/mobx/checkoutStore';
import { localeStore } from 'src/mobx/localesStore';
import { userStore } from 'src/mobx/userStore';
import { getWalletCurrency } from 'src/utils/helpers';
import './style.scss';

@observer
export default class CheckoutWallet extends React.Component {
  onClick = (value: boolean) => () => {
    if (this.disabled || value === !!cartStore.checkout.use_wallet) return;
    cartStore.setCheckoutWallet(Number(!cartStore.checkout.use_wallet));
  };

  get disabled(): boolean {
    return (
      Boolean(cartStore.checkout.promocode) ||
      !userStore.user.wallet?.balance ||
      checkoutStore.reorderStore?.order?.promocode
    );
  }

  public render() {
    if (cartStore.checkout.payment_type === PAYMENT_TYPES.POINTS) return null;

    return (
      <div className="mb-3">
        <div className={`wallet-toggle d-flex flex-row background-secondary`}>
          <button
            className={`wallet-toggle-option ${
              !cartStore.checkout.use_wallet ? 'active' : ''
            } d-flex flex-grow-1 py-2 align-items-center justify-content-center`}
            onClick={this.onClick(false)}
          >
            <div className="d-flex flex-row color-darkgray align-items-center">
              <p className="family-bold text-size-14">{localeStore.t('keep_wallet')}</p>
              <p
                className={`text-size-10 background-secondary wallet-toggle-balance ${
                  !cartStore.checkout.use_wallet ? 'color-primary' : ''
                }`}
              >
                {userStore.user.wallet?.balance}
              </p>
              <p className="family-bold text-size-14">{getWalletCurrency()}</p>
            </div>
          </button>

          <button
            className={`wallet-toggle-option ${
              cartStore.checkout.use_wallet ? 'active' : ''
            } d-flex flex-grow-1 py-2 align-items-center justify-content-center`}
            onClick={this.onClick(true)}
          >
            <div className="d-flex flex-row color-darkgray align-items-center">
              <p className="family-bold text-size-14">{localeStore.t('use_wallet')}</p>
              <p
                className={`text-size-10 background-secondary wallet-toggle-balance ${
                  cartStore.checkout.use_wallet ? 'color-primary' : ''
                }`}
              >
                {userStore.user.wallet?.balance}
              </p>
              <p className="family-bold text-size-14">{getWalletCurrency()}</p>
            </div>
          </button>
        </div>
      </div>
    );
  }
}
